<template>
  <div class="w-full text-left">
    <div class="relative pb-5 border-b border-gray-200 sm:pb-0 px-5 mt-5">
      <div class="md:flex md:items-center md:justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Users</h3>
        <div class="mt-3 flex md:mt-0 md:top-3 md:right-0">
          <button
            @click="goto('/users/create')"
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Invite user
          </button>
        </div>
      </div>
      <div class="mt-4">
        <div class="sm:hidden">
          <label for="current-tab" class="sr-only">Select a tab</label>
          <select
            id="current-tab"
            name="current-tab"
            class="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            @change="onChange($event.target.selectedIndex)"
          >
            <option v-for="(tab) in tabs" :key="tab.name" :selected="tab.current">
              {{ tab.name }}
            </option>
          </select>
        </div>
        <div class="hidden sm:block">
          <nav class="-mb-px flex space-x-8">
            <a
              @click="onChange(index)"
              v-for="(tab, index) in tabs"
              :key="tab.name"
              :class="[
                tab.current
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
              ]"
              :aria-current="tab.current ? 'page' : undefined"
            >
              {{ tab.name }}
              <span class="bg-indigo-100 text-indigo-600 hidden ml-2 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block">{{userCount(index)}}</span>
            </a>
          </nav>
        </div>
      </div>
    </div>
    <div class="bg-white overflow-hidden shadow sm:rounded-md xl:mt-5">
      <ul class="divide-y divide-gray-200">
        <li
          v-for="(useritem) in filteredUsers"
          :key="useritem._id"
          @click="goto('/users/' + useritem._id)"
          class="cursor-pointer"
        >
          <a class="block hover:bg-gray-50">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <div class="flex-shrink-0">
                <span class="inline-flex items-center justify-center h-12 w-12 rounded-full" v-bind:style="{backgroundColor:getRGB(useritem.email)}">
                  <span class="text-lg font-medium leading-none text-white">{{useritem.email[0]}}</span>
                </span>
                </div>
                <div
                  class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4"
                >
                  <div>
                    <p class="text-sm font-medium text-indigo-600 truncate">
                      {{ useritem.firstname }} {{ useritem.lastname }}
                    </p>
                    <p class="mt-2 flex items-center text-sm text-gray-500">
                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                        />
                        <path
                          d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                        />
                      </svg>
                      <span class="truncate">{{ useritem.email }}</span>
                    </p>
                  </div>
                  <!-- <div class="hidden md:block">
                    <div>
                      <p class="text-sm text-gray-900">Applied on test</p>
                      <p class="mt-2 flex items-center text-sm text-gray-500">
                        <svg
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        Open
                      </p>
                    </div>
                  </div> -->
                </div>
              </div>
              <div>
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </a>
          <!-- <a class="block hover:bg-gray-50">
            <div class="px-4 py-4 flex items-center sm:px-6">
              <div
                class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
              >
                <div class="truncate">
                  <div class="flex text-sm">
                    <p class="font-medium text-indigo-600 truncate">
                      {{ useritem.name }}
                    </p>
                    <p class="ml-1 flex-shrink-0 font-normal text-gray-500">
                      in Antwerpen
                    </p>
                  </div>
                  <div class="mt-2 flex">
                    <div class="flex items-center text-sm text-gray-500">

                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p>
                        Closing on
                        <time datetime="2020-01-07">January 7, 2020</time>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-5 flex-shrink-0">
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </a> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import avatarGenerator from "./../../../services/avatarGenerator";
import { mapGetters } from "vuex";
const tabs = [
  // { name: "All user", slug: "all", current: true },
  { name: "Admins", slug: "admin", current: true },
  { name: "Customers", slug: "customer", current: false },
  { name: "Cleaners", slug: "cleaner", current: false },
];
export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      tabs,
      currentTab: "admin",
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
    ...mapGetters("users", {
      users: "userList",
    }),
    filteredUsers() {
      return this.users.filter((i) => {
        if (this.currentTab == "all") return true;
        return i.type == this.currentTab;
      });
    },
  },
  methods: {
    deleteUser(id) {
      this.$store.dispatch("users/deleteUser", id);
    },
    goto(path) {
      this.$router.push({ path });
    },
    onChange(index) {
      this.tabs.forEach((tab) => {
        tab.current = false;
      });
      this.tabs[index].current = true;
      this.currentTab = this.tabs[index].slug;
    },
    userCount(index){
      let filter= this.users.filter((i) =>{
        return i.type == this.tabs[index].slug;
      });
      return filter.length
    },
    getRGB(name){
      return avatarGenerator.getRGB(name)
    }
  },
  beforeCreate() {
    this.$store.dispatch("users/getUsers");
  },
};
</script>

<style lang="css" scoped></style>